import { render } from "./SummaryOverview.vue?vue&type=template&id=0c91172b&scoped=true&ts=true"
import script from "./SummaryOverview.vue?vue&type=script&lang=ts"
export * from "./SummaryOverview.vue?vue&type=script&lang=ts"

import "./SummaryOverview.vue?vue&type=style&index=0&id=0c91172b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c91172b"]])

export default __exports__